import Vue from "vue";
import VueI18n from "vue-i18n";

import ConsentComponent from "./Consent.vue";

let $vm;

// export default (context, inject) => {
//     const Consent = Vue.extend(ConsentComponent)

//     if (!$vm) {
//         $vm = new Consent({ el: document.createElement('div') })
//         document.body.appendChild($vm.$el)
//     }

//     inject('consent', $vm)
// }

export default {
    install(vue, i18n) {
        Vue.use(VueI18n);
        const Consent = Vue.extend(ConsentComponent);

        if (!$vm) {
            $vm = new Consent({
                el: document.createElement("div"),
                i18n
            });
            $vm.webcc = vue.webcc;
            document.body.appendChild($vm.$el);
        }

        vue.consent = $vm;
        vue.prototype.$consent = $vm;
    }
};
